import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get } from 'lodash';

import {
  REQUEST_MANAGER_OPENED_CLAIMS,
  REQUEST_SAGIS_LAWYER_ASSIGNED_CLAIMS,
} from 'containers/ManagerOpenedClaimsPage/constants';
import {
  setManagerOpenedClaims,
  setSagisLawyerAssignedClaims,
} from 'containers/ManagerOpenedClaimsPage/actions';
import userToken from 'containers/services/security/access-token-storage';

export function* requestManagerOpenedClaims(action: any) {
  const { status, page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setManagerOpenedClaims);
}

export function* requestManagerOpenedClaimsSaga() {
  yield takeLeading(REQUEST_MANAGER_OPENED_CLAIMS, requestManagerOpenedClaims);
}

export function* fetchSagisLawyerAssignedClaims(action: any) {
  const token = get(userToken.get(), 'token');

  if (!token) return;
  const { claimNumbers } = action;
  const path = `/corporeal/sagis-lawyer-assignment`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ claimNumbers }),
  };
  yield callApi(path, {}, options, [], setSagisLawyerAssignedClaims);
}

export function* fetchSagisLawyerAssignedClaimsSaga() {
  yield takeLeading(
    REQUEST_SAGIS_LAWYER_ASSIGNED_CLAIMS,
    fetchSagisLawyerAssignedClaims,
  );
}

export default [
  requestManagerOpenedClaimsSaga,
  fetchSagisLawyerAssignedClaimsSaga,
];
